<template>
    <div>
        <multi-posting-discover-list-item
            v-if="!hasMultiPostingSubscription"
            :title="$t('multi-posting.discover.contracts.title')"
            :description="$t('multi-posting.discover.contracts.description')"
            compact
        />
        <loading v-else-if="loading"></loading>
        <div v-else class="grid grid-cols-1 xl:grid-cols-2 gap-16">
            <div v-for="contract in contracts" class="h-full">
                    <div class="flex flex-col justify-between rounded border p-24 h-564 overflow-hidden shadow">
                        <div>
                            <div class="flex justify-center items-center text-white bg-primary rounded py-2 mb-24">
                                <p class="text-white">{{ $t('multi-posting.campaigns.my_contract') }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p v-if="contract.slots">{{ `${contract.slots} ${$tc('general.slots', contract.slots)}` }}</p>
                            </div>
                        </div>
                        <div class="flex justify-center items-center w-full h-156">
                            <img :src="contract.logo_url" :alt="`logo-${contract.name}`" class="max-h-156">
                        </div>
                        <div class="my-16">
                            <p class="text-body my-2">{{ contract.name + getAlias(contract) }}</p>
                            <p class="text-body my-2">{{ contract.group && contract.group.name && contract.group.name !== 'Default' ? contract.group.name : $t('multi-posting.contracts.groups.group.default.title.label') }}</p>
                            <a :href="contract._raw.channel.url" target="_blank" class="link-default">
                                {{ contract._raw.channel.url }}
                            </a>
                        </div>
                        <div class="flex flex-col items-center gap-12 w-full">
                            <simple-button
                                v-if="isSelectedItem(contract.contract_id)"
                                display="danger"
                                look="primary"
                                class="grow w-full"
                                @click="removeFromCampaign(contract)"
                            >
                                {{ $t('multi-posting.campaigns.form.remove_from_campaign') }}
                            </simple-button>
                            <simple-button
                                v-else
                                display="secondary"
                                look="primary"
                                class="grow w-full"
                                @click="addToCampaign(contract)"
                            >
                                {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                            </simple-button>

                            <simple-button
                                display="primary"
                                class="grow w-full"
                                @click="moreInformation(contract)"
                            >
                                {{ $t('general.more_information') }}
                            </simple-button>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import Loading from "../../ui/Loading.vue";
import SimpleButton from "../../ui/SimpleButton.vue";
import {mapActions, mapState} from "pinia";
import PaidSubscription from "../../../models/PaidSubscription";
import {useMainStore} from "../../../state/store";
import MultiPostingDiscoverListItem from "../MultiPostingDiscoverListItem.vue";
import {useMultiPostingStore} from "../../../state/modules/multiPosting";
import {useRepo} from "pinia-orm";

export default {
    name: 'Contracts',
    components: {MultiPostingDiscoverListItem, SimpleButton, Loading},
    props: {
        selectedItems: { type: Array, required: true },
        contracts: { type: Array, required: true },
        loading: { type: Boolean, required: true },
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        hasMultiPostingSubscription() {
            return !!this.multiPostingSubscription && this.currentCompany.multiposting_status === 'active';
        },
        multiPostingSubscription() {
            return useRepo(PaidSubscription)
                .where('type', 'multi-posting')
                .where('company_id', this.currentCompany.id)
                .where('active', true)
                .first();
        },
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['removeSelectedItemById', 'addSelectedItems']),
        isSelectedItem(contractId) {
            return this.selectedItems.filter(x => x.contract_id === contractId).length > 0;
        },
        addToCampaign(contract) {
            if (this.isSelectedItem(contract.contract_id)) {
                return;
            }
            this.addSelectedItems([{
                id: contract.product_id,
                channel_id: contract.channel_id,
                contract_id: contract.contract_id,
                name: `${this.$t('multi-posting.campaigns.form.my_contract')}: ${contract.name}${this.getAlias(contract)}`,
                duration: {
                    period: contract.postingDurationDays
                },
                price: {
                    amount: contract.credits,
                    currency: 'credits'
                },
                type: 'contract',
                logo_square_url: contract.logo_square_url,
            }]);
        },
        removeFromCampaign(contract) {
            this.removeSelectedItemById({itemId: contract.contract_id, ref: 'contract_id'});
        },
        moreInformation(contract)  {
            this.$emit('more-information', contract);
        },
        getAlias(contract) {
            return contract && contract.alias ? ` (${contract.alias})` : '';
        },
    },
}
</script>
